import dayjs, { Dayjs } from "dayjs";

export class ActivityFilterInfo {
    start: Dayjs | null;
    finish: Dayjs | null;
    future: boolean;
    connected: boolean | null;
    displayId: string | null;
    name: string | null;
    activityId: string | null;
    wbs: string | null;
    wbsName: string | null;
    vendorUniqueId: string | null;
    sortBy: string | null;
    sortDirection: "asc" | "desc";
    page: number | null;
    pageSize: number | null;
    textSearch: string | null;

    constructor() {
        this.start = null;
        this.finish = null;
        this.future = false;
        this.connected = null;
        this.displayId = null;
        this.name = null;
        this.activityId = null;
        this.wbs = null;
        this.wbsName = null;
        this.vendorUniqueId = null;
        this.sortBy = "start";
        this.sortDirection = "asc";
        this.page = null;
        this.pageSize = 50;
        this.textSearch = null;
    }

    toApiObject() {
        return {
            start: this.start ? this.start.toISOString() : null,
            finish: this.finish ? this.finish.toISOString() : null,
            future: this.future,
            connected: this.connected,
            display_id: this.displayId,
            name: this.name,
            activity_id: this.activityId,
            wbs: this.wbs,
            wbs_name: this.wbsName,
            vendor_unique_id: this.vendorUniqueId,
            sort_by: this.sortBy,
            sort_direction: this.sortDirection,
            page: this.page,
            page_size: this.pageSize,
            text_search: this.textSearch,
        };
    }
    static fromApiObject(obj: any, timezone: string): ActivityFilterInfo {
        const newFilter = new ActivityFilterInfo();
        newFilter.start = obj["start"] ? dayjs(obj["start"]).tz(timezone) : null;
        newFilter.finish = obj["finish"] ? dayjs(obj["finish"]).tz(timezone) : null;
        newFilter.future = obj["future"] || false;
        newFilter.connected = obj["connected"] !== undefined ? obj["connected"] : null;
        newFilter.displayId = obj["display_id"] || null;
        newFilter.name = obj["name"] || null;
        newFilter.activityId = obj["activity_id"] || null;
        newFilter.wbs = obj["wbs"] || null;
        newFilter.wbsName = obj["wbs_name"] || null;
        newFilter.vendorUniqueId = obj["vendor_unique_id"] || null;
        newFilter.sortBy = obj["sort_by"] || "start";
        newFilter.sortDirection = obj["sort_direction"] || "asc";
        newFilter.page = obj["page"] !== undefined ? obj["page"] : null;
        newFilter.pageSize = obj["page_size"] !== undefined ? obj["page_size"] : null;
        newFilter.textSearch = obj["text_search"] || null;
        return newFilter;
    }

    toUrlSearchParams() {
        const params = new URLSearchParams();
        if (this.start) {
            params.set("start", this.start.toISOString());
        }
        if (this.finish) {
            params.set("finish", this.finish.toISOString());
        }
        if (this.future) {
            params.set("future", this.future.toString());
        }
        if (this.connected !== null) {
            params.set("connected", this.connected.toString());
        }
        if (this.displayId) {
            params.set("display_id", this.displayId);
        }
        if (this.name) {
            params.set("name", this.name);
        }
        if (this.activityId) {
            params.set("activity_id", this.activityId);
        }
        if (this.wbs) {
            params.set("wbs", this.wbs);
        }
        if (this.wbsName) {
            params.set("wbs_name", this.wbsName);
        }
        if (this.vendorUniqueId) {
            params.set("vendor_unique_id", this.vendorUniqueId);
        }
        if (this.sortBy) {
            params.set("sort_by", this.sortBy);
        }
        if (this.sortDirection) {
            params.set("sort_direction", this.sortDirection);
        }
        // Page is expected to be 1-based when set; convert from MUI's 0-based index at the call site
        if (this.page !== undefined && this.page !== null) {
            params.set("page", this.page.toString());
        }
        if (this.pageSize !== undefined && this.pageSize !== null) {
            params.set("page_size", this.pageSize.toString());
        }
        if (this.textSearch) {
            params.set("text_search", this.textSearch);
        }
        return params;
    }
}
export const columnFieldsToSortableNames = (columnField: string) => {
    switch (columnField) {
        case "userFacingId":
            return "activity_id";
        case "userFacingWbsName":
            return "wbs_name";
        case "activitiesOrders":
            return "activities_orders";
        default:
            return columnField;
    }
};
